const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorTask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m180 492h-60c-55.228 0-100-44.771-100-100v-272c0-55.229 44.772-100 100-100h60c-55.228 0-100 44.771-100 100v272c0 55.229 44.772 100 100 100zm144-115c0-51.123 33.362-94.446 79.5-109.407-72.716-24.604-151.547 32.387-150.499 109.408-1.051 77.006 77.795 134.024 150.499 109.406-46.138-14.961-79.5-58.284-79.5-109.407z",
    fill: "#ffffff",
    "data-original": "#cee1f2",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m224 512h-104c-66.168 0-120-53.832-120-120v-272c0-66.168 53.832-120 120-120h272c66.168 0 120 53.832 120 120v100c-1.056 26.536-38.953 26.516-40 0v-100c0-44.112-35.888-80-80-80h-272c-44.112 0-80 35.888-80 80v272c0 44.112 35.888 80 80 80h104c26.536 1.056 26.516 38.953 0 40zm103-402c0-11.046-8.954-20-20-20h-102c-26.536 1.056-26.516 38.953 0 40h102c11.046 0 20-8.954 20-20zm185 267c0-74.439-60.561-135-135-135-179.104 7.417-179.035 262.617 0 270 74.439 0 135-60.561 135-135zm-40 0c0 52.383-42.617 95-95 95-126.036-5.22-125.987-184.804 0-190 52.383 0 95 42.617 95 95z",
    fill: "#001160",
    "data-original": "#0023c4",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405.285 377 15.858-15.858c7.81-7.811 7.81-20.474 0-28.284-7.811-7.811-20.475-7.811-28.285 0l-15.858 15.857-15.857-15.857c-7.811-7.811-20.475-7.811-28.285 0s-7.81 20.474 0 28.284l15.857 15.858-15.858 15.858c-7.81 7.811-7.81 20.474 0 28.284 7.811 7.811 20.474 7.811 28.285 0l15.858-15.857 15.857 15.857c7.811 7.811 20.474 7.811 28.285 0 7.81-7.811 7.81-20.474 0-28.284z",
    fill: "#ff0000",
    "data-original": "#ff5cf4",
    style: {},
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorTask);
export default __webpack_public_path__ + "static/media/error-task.f934b33b68ead96f64fa356f168e5af8.svg";
export { ForwardRef as ReactComponent };